module.exports = __webpack_public_path__ + "static/media/chart-icon.71409161.svg";